module.exports = __webpack_public_path__ + "static/media/family_issues.0eef48a7.jpg";